<div class="password-resets-dialog">
  <div class="flex items-start justify-between !px-4 !py-3 border-b border-slate-100 gap-3">
    <div class="flex flex-col gap-0.5 min-w-0">
      <h2 mat-dialog-title class="!m-0 !p-0 text-[18px] font-bold text-slate-800 leading-tight">
        Password reset history
      </h2>
      <p *ngIf="data.employeeName" class="!m-0 text-[13px] text-slate-500 truncate">
        {{ data.employeeName }}
      </p>
    </div>
    <button mat-icon-button class="text-slate-400 hover:text-slate-600 transition-colors shrink-0"
      (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div *ngIf="loading" class="py-8 text-center text-[14px] text-slate-500">
      Loading…
    </div>

    <div *ngIf="!loading && error" class="py-8 text-center text-[14px] text-slate-600">
      {{ error }}
    </div>

    <div *ngIf="!loading && !error && rows.length === 0" class="py-8 text-center text-[14px] text-slate-500">
      No history yet.
    </div>

    <ul *ngIf="!loading && !error && rows.length" class="reset-list">
      <li *ngFor="let row of rows" class="reset-row">
        <span class="reset-kind">{{ row.label }}</span>
        <span class="reset-when">{{ row.when }}</span>
        <span *ngIf="row.who" class="reset-who">by {{ row.who }}</span>
      </li>
    </ul>
  </mat-dialog-content>
</div>
